export const KEY_LOGIN_INFO = 'KEY_LOGIN_INFO'
export const KEY_LOGIN_CELLPHONE_INFO = 'KEY_LOGIKEY_LOGIN_CELLPHONE_INFON_INFO'
export const KEY_USER_TOKEN = 'KEY_USER_TOKEN'
export const KEY_FAMI_CONFIG = 'KEY_FAMI_CONFIG'
export const KEY_PALM_CONFIG = 'KEY_PALM_CONFIG'
export const KEY_AREA_CONFIG = 'KEY_AREA_CONFIG'
export const KEY_BNAK_CONFIG = 'KEY_BANK_CONFIG'
export const KEY_HOLIDAYS_CONFIG = 'KEY_HOLIDAYS_CONFIG'
export const KEY_IBOX_POSTBOXES_CONFIG = 'KEY_IBOX_POSTBOXES_CONFIG'
export const KEY_HILIFE_CONFIG = 'KEY_HILIFE_CONFIG'
export const KEY_SEVEN_ELEVEN_CONFIG = 'KEY_SEVEN_ELEVEN_CONFIG'
export const KEY_ITEM_CATEGORIES_CONFIG = 'KEY_ITEM_CATEGORIES_CONFIG'
export const KEY_CONFIG_LAST_VERSION = 'KEY_CONFIG_LAST_VERSION'

export const KEY_NEWGIFT_TIP_SHOWN = 'KEY_NEWGIFT_TIP_SHOWN'
export const KEY_NEWNEED_TIP_SHOWN = 'KEY_NEWNEED_TIP_SHOWN'

export const KEY_ACTIVITY_RESERVATION_DATE = 'KEY_ACTIVITY_RESERVATION_DATE'
export const KEY_BOOKED_RESERVATION = 'KEY_BOOKED_RESERVATION'

export const KEY_RATE_SENDER_OPERATION_COUNT = 'KEY_RATE_SENDER_OPERATION_COUNT'
export const KEY_RATE_RECEIVER_OPERATION_COUNT = 'KEY_RATE_RECEIVER_OPERATION_COUNT'
export const KEY_RATE_DIALOG_CLICK_RATE = 'KEY_RATE_DIALOG_CLICK_RATE'
export const KEY_RATE_DIALOG_LAST_SHOW_TIME = 'KEY_RATE_DIALOG_LAST_SHOW_TIME'

export const KEY_ANNUAL_REPORT_SHOWED = 'KEY_ANNUAL_REPORT_SHOWED'

export const KEY_LOVEBOX_LAST_SHOWED_SHELVE_TIME = 'KEY_LOVEBOX_LAST_SHOWED_SHELVE_TIME'

export const KEY_LOVEBOX_REQUEST_RULES_SHOWN = 'KEY_LOVEBOX_REQUEST_RULES_SHOWN'
export const KEY_FLASH_GIFTS_RULES_SHOWN = 'KEY_FLASH_GIFTS_RULES_SHOWN'
export const KEY_BRAND_GIFTS_RULES_SHOWN = 'KEY_BRAND_GIFTS_RULES_SHOWN'
export const KEY_DORM_GIFTS_RULES_SHOWN = 'KEY_DORM_GIFTS_RULES_SHOWN'
export const KEY_GIFTS_RULES_SHOWN = 'KEY_GIFTS_RULES_SHOWN'
export const KEY_NEEDS_RULES_SHOWN = 'KEY_NEEDS_RULES_SHOWN'
export const KEY_COMMONWWAL_NEEDS_RULES_SHOWN = 'KEY_COMMONWWAL_NEEDS_RULES_SHOWN'

export const KEY_LOVEBOX_ADD_CART_RULES_SHOWN = 'KEY_LOVEBOX_ADD_CART_RULES_SHOWN'

export const KEY_DEVICE_UUID = 'KEY_DEVICE_UUID'

export const KEY_LAST_USED_EMOJI = 'KEY_LAST_USED_EMOJI'

export const KEY_ANNUAL_REPORT_SHOWED_YEARS = 'KEY_ANNUAL_REPORT_SHOWED_YEARS'

export const KEY_RATE_DIALOG_TYPE_RATE_COUNT = 'KEY_RATE_DIALOG_TYPE_RATE_COUNT'

export const KEY_RECENTLY_SEARCH_KEYWORDS = 'KEY_RECENTLY_SEARCH_KEYWORDS'

export const KEY_APP_FONT_SIZE = 'KEY_APP_FONT_SIZE'

export const KEY_DORM_ZONE_SWITCH_STATE = 'KEY_DORM_ZONE_SWITCH_STATE'
export const KEY_FESTIVAL_EARTH_DAY_SHOWN_IDS = 'KEY_FESTIVAL_EARTH_DAY_SHOWN_IDS'

// GC減碳帳戶數據緩存
export const KEY_CARBON_ACCOUNT_TRAIL_CACHE = 'KEY_CARBON_ACCOUNT_TRAIL_CACHE'

export const KEY_CARBON_LABELLING_GROUPS_RULES_SHOWN = 'KEY_CARBON_LABELLING_GROUPS_RULES_SHOWN'

// Mediatek token
export const KEY_MEDIATEK_2025GIVINGTREE_TOKEN = 'KEY_MEDIATEK_2025GIVINGTREE_TOKEN'
export const KEY_MEDIATEK_2025GIVINGTREE_USER_INFO = 'KEY_MEDIATEK_2025GIVINGTREE_USER_INFO'

export const session = {
  save (key, item) {
    if (!window.sessionStorage) {
      console.warn('當前瀏覽器不支持sessionStorage')
      return null
    }
    if (typeof item === 'object') {
      window.sessionStorage.setItem(key, JSON.stringify(item))
    } else {
      window.sessionStorage.setItem(key, item)
    }
  },
  set (key, item) {
    // alias for save
    return this.save(key, item)
  },
  get (key, isObject = false) {
    if (!window.sessionStorage) {
      console.warn('當前瀏覽器不支持sessionStorage')
      return null
    }
    const str = window.sessionStorage.getItem(key)
    return str ? (isObject ? JSON.parse(str) : str) : null
  },
  remove (key) {
    if (!window.sessionStorage) {
      console.warn('當前瀏覽器不支持sessionStorage')
      return null
    }
    window.sessionStorage.removeItem(key)
  }
}

export const local = {
  save (key, item) {
    if (!window.localStorage) {
      console.warn('當前瀏覽器不支持localStorage')
      return null
    }
    if (typeof item === 'object') {
      window.localStorage.setItem(key, JSON.stringify(item))
    } else {
      window.localStorage.setItem(key, item)
    }
  },
  get (key, isObject = false) {
    if (!window.localStorage) {
      console.warn('當前瀏覽器不支持localStorage')
      return null
    }
    const str = window.localStorage.getItem(key)
    return str ? (isObject ? JSON.parse(str) : str) : null
  },
  remove (key) {
    if (!window.localStorage) {
      console.warn('當前瀏覽器不支持localStorage')
      return null
    }
    window.localStorage.removeItem(key)
  },
  hasValue (key, item) {
    if (!window.localStorage) {
      return null
    }
    const str = window.localStorage.getItem(key)
    if (!str) {
      return false
    }

    const arrValue = JSON.parse(str)
    return arrValue.includes(item)
  },
  pushValue (key, item) {
    if (!window.localStorage) {
      return null
    }
    let arrValue = []
    const str = window.localStorage.getItem(key)
    if (str) {
      arrValue = JSON.parse(str)
    }
    arrValue.push(item)
    window.localStorage.setItem(key, JSON.stringify(arrValue))
  }
}
